// stores/legitimuz-status.ts
import { defineStore } from 'pinia';


export const useLegitimuzStatusStore = defineStore('legitimuzStatus', () => {
  const isApproved = ref(false);
  const userStatus = ref('');
  const isVPNDetected = ref(false);
  const lastCheckTime = ref(0);
  const isCheckInProgress = ref(false);
  


  async function checkStatus(force = false) {

    if (isCheckInProgress.value) {
      return isApproved.value;
    }
    
    if (!force ) {
      return isApproved.value;
    }
 
    isCheckInProgress.value = true;
    
    try {
      const config = useRuntimeConfig();
      if (!config.public.LEGITIMUZ_API_TOKEN) {
        return true;
      }
     
      const data = await $fetch('/api/legitimuzStatus', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${useCookie('jwt').value}`
        }
      });
      
      if (data) {
        userStatus.value = data.user_status;
        isVPNDetected.value = data.user_status === 'ip_blocked';
        isApproved.value = data.isApproved;
        lastCheckTime.value = Date.now();
      }
      
      return isApproved.value;
    } catch (error) {
      console.error('Error checking Legitimuz status:', error);
      isVPNDetected.value = false;
      return false;
    } finally {
      isCheckInProgress.value = false;
    }
  };

  function setStatus(newStatus: string) {
    console.log(`Directly setting Legitimuz status to: ${newStatus}`);
    userStatus.value = newStatus;
    isApproved.value = newStatus === 'approved'; 
    isVPNDetected.value = newStatus === 'ip_blocked';
    console.log(`Store state updated: userStatus=${userStatus.value}, isApproved=${isApproved.value}, isVPNDetected=${isVPNDetected.value}`);
  }
  
  return {
    // Exposed state
    isApproved,
    userStatus,
    isVPNDetected,
    lastCheckTime,
  
    
    // Actions
    checkStatus,
    setStatus
  };
});

